/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'
import { TopicApplication } from '@/utils/constants'

export const useUpdateTopic = (topicID: string) => {
  const axios = useContext(AxiosContext)
  return useMutation({
    mutationKey: [ReactQueryKeys.UPDATE_TOPIC, topicID],
    mutationFn: async (topicName: string) => {
      const response = await axios.api.post('ajax/topics', {
        requestType: 'topicUpdate',
        'topicData[action]': 'update',
        'topicData[topicApplication]': TopicApplication.Oddlyou,
        'topicData[topicName]': topicName,
        'topicData[topicDescription]': '',
        'topicData[topicID]': topicID,
        format: 'json',
      })
      return response.data
    },
  })
}
